import { Component, Input } from '@angular/core';
import { ChartBarComponent, ChartBarConfig } from './chart-bar.component';

@Component({
  selector: 'app-chart-bar-multiple',
  standalone: true,
  template: `
    <div class="grid pt-2 pb-2">
      @for (chart of config; track $index) {
        <div class="col-12 mb-2" [class]="'md:col-' + (chart.col ?? 12)">
          <div class="dash-card h-full">
            @if (chart.title) {
              <div class="dash-header">
                <div class="dash-title">{{ chart.title }}</div>
              </div>
            }
            <div class="dash-body">
              <app-chart-bar [config]="chart" [data]="data"/>
            </div>
          </div>
        </div>
      }
    </div>
  `,
  imports: [ChartBarComponent]
})
export class ChartBarMultipleComponent {

  @Input() config: ChartBarConfig[] = [];
  @Input() data: any[] = [];
}
